/* 
 	* 公告详情组件 
 	* 描述：具体公告内容部分
 	* 创建时间：2017-03-28 
 	* 创建人：baixx 
 	* 修改时间：2017-3-31
 	* 修改人：baixx
*/
<template>
	<div class="ibox float-e-margins ibox-content" style="position: relative; height: 100%;">
		<!--表单查询开始-->
		<div class="form-horizontal">
			<div class="form-group">
				<label class="col-sm-1 control-label">标题</label>
				<div class="col-sm-11">
					<input type="text" class="form-control" v-model="data.title" readonly >
				</div>
			</div>
			<div class="form-group">
				<label class="col-sm-1 control-label">时间</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model="data.sendDate" readonly>
				</div>
				<label class="col-sm-1 control-label">来源</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model="data.sourceName" readonly>
				</div>
				<label class="col-sm-1 control-label">重要度</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model="data.statusName" readonly>
				</div>
			</div>
			<div class="form-horizontal">
				<div class="form-group">
			        <label class="col-sm-1 text-right control-label">内容</label>
			        <div class="col-sm-11">
				        <textarea class="form-control" rows="8" v-model="data.content" readonly></textarea>
				    </div>
			     </div>
			</div>
			<div class="form-group">
				<div class="col-sm-12 text-center">
					<button class="btn btn-primary" @click="close">关闭</button>
				</div>
			</div>
		</div>
		<!--表单查询结束-->			
	</div>
</template>
<script>
	export default {
		name: "PageNoticeDetails",
		props: ["data"],
		methods: {
			close(){
				this.$emit('toClose','');
			}
		}
	}
</script>



// WEBPACK FOOTER //
// PageNoticeDetails.vue?054c3b6c